'use client';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import FaqsHero from '../faqs-hero';
import FaqsList from '../faqs-list';
import FaqsForm from '../faqs-form';
import FaqsCategory from '../faqs-category';

// ----------------------------------------------------------------------

export default function FaqsView() {
  return (
    <>
      <FaqsHero />

      <Container
        sx={{
          pb: 10,
          pt: { xs: 10, md: 15 },
          position: 'relative',
        }}
      >
        <FaqsCategory />

        <Stack
          spacing={2}
          alignItems="center"
          sx={{
            textAlign: 'center',
            my: { xs: 6, md: 10 },
            maxWidth: 720,
            mx: 'auto',
          }}
        >
          <Typography variant="h3">Frequently asked questions</Typography>

          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Everything you need to know about our product and services.
          </Typography>
        </Stack>
        <Divider sx={{ mb: { xs: 6, md: 8 } }} />
        <Box
          gap={10}
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
          }}
        >
          <FaqsList />

          <FaqsForm />
        </Box>
      </Container>
    </>
  );
}
